import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "006_ledger_payment_runtime_columns",
  version: "1.4.2",
  ignoreErrors: [
    "no such table: accounting_gl_entries",
    "no such table: accounting_payment_allocations",
  ],
  sql: `
ALTER TABLE \`accounting_gl_entries\` ADD COLUMN \`currency_code\` text NOT NULL DEFAULT 'THB';
ALTER TABLE \`accounting_gl_entries\` ADD COLUMN \`exchange_rate\` real NOT NULL DEFAULT 1;
ALTER TABLE \`accounting_gl_entries\` ADD COLUMN \`line_no\` integer NOT NULL DEFAULT 0;
ALTER TABLE \`accounting_gl_entries\` ADD COLUMN \`cost_center_id\` text;
ALTER TABLE \`accounting_gl_entries\` ADD COLUMN \`line_reference_module\` text;
ALTER TABLE \`accounting_gl_entries\` ADD COLUMN \`line_reference_doctype\` text;
ALTER TABLE \`accounting_gl_entries\` ADD COLUMN \`line_reference_id\` text;
ALTER TABLE \`accounting_gl_entries\` ADD COLUMN \`deleted_at\` text;
ALTER TABLE \`accounting_gl_entries\` ADD COLUMN \`deleted_by\` text;

DROP INDEX IF EXISTS \`gl_unique_post_idx\`;

WITH numbered_gl AS (
  SELECT
    \`id\`,
    ROW_NUMBER() OVER (
      PARTITION BY \`company_id\`, \`source_type\`, \`source_id\`, \`is_reversal\`
      ORDER BY \`created_at\`, \`id\`
    ) - 1 AS next_line_no
  FROM \`accounting_gl_entries\`
)
UPDATE \`accounting_gl_entries\`
SET \`line_no\` = (
  SELECT numbered_gl.next_line_no
  FROM numbered_gl
  WHERE numbered_gl.\`id\` = \`accounting_gl_entries\`.\`id\`
)
WHERE \`id\` IN (SELECT \`id\` FROM numbered_gl);

CREATE INDEX IF NOT EXISTS \`gl_line_ref_idx\`
  ON \`accounting_gl_entries\` (\`company_id\`, \`line_reference_module\`, \`line_reference_id\`);

CREATE UNIQUE INDEX IF NOT EXISTS \`gl_unique_post_idx\`
  ON \`accounting_gl_entries\` (\`company_id\`, \`source_type\`, \`source_id\`, \`line_no\`)
  WHERE \`is_reversal\` = 0;

ALTER TABLE \`accounting_payment_allocations\` ADD COLUMN \`allocation_date\` text;
ALTER TABLE \`accounting_payment_allocations\` ADD COLUMN \`allocation_type\` text NOT NULL DEFAULT 'invoice';
ALTER TABLE \`accounting_payment_allocations\` ADD COLUMN \`status\` text NOT NULL DEFAULT 'active';
ALTER TABLE \`accounting_payment_allocations\` ADD COLUMN \`gl_source_id\` text;
ALTER TABLE \`accounting_payment_allocations\` ADD COLUMN \`reversal_of\` text;
ALTER TABLE \`accounting_payment_allocations\` ADD COLUMN \`reversed_at\` text;
ALTER TABLE \`accounting_payment_allocations\` ADD COLUMN \`reversed_by\` text;
ALTER TABLE \`accounting_payment_allocations\` ADD COLUMN \`reversal_reason\` text;
ALTER TABLE \`accounting_payment_allocations\` ADD COLUMN \`created_by\` text;
ALTER TABLE \`accounting_payment_allocations\` ADD COLUMN \`updated_at\` text;
ALTER TABLE \`accounting_payment_allocations\` ADD COLUMN \`updated_by\` text;

CREATE INDEX IF NOT EXISTS \`pay_alloc_payment_status_idx\`
  ON \`accounting_payment_allocations\` (\`payment_id\`, \`status\`);

CREATE INDEX IF NOT EXISTS \`pay_alloc_invoice_status_idx\`
  ON \`accounting_payment_allocations\` (\`invoice_id\`, \`status\`);
  `.trim(),
};
